/**
 * RequireAdmin Component
 * 
 * Protects routes that require admin role.
 * Redirects non-admin users to /family/dashboard
 */

import { Navigate } from 'react-router-dom';
import { useFamilyAuth } from '../contexts/FamilyAuthContext';

function RequireAdmin({ children }) {
  const { familyUser, loading } = useFamilyAuth();

  // Show loading state while auth is being checked
  if (loading) {
    return (
      <div className="min-h-screen bg-[#050816] text-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#5B4B8A] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-neutral-400">Überprüfe Berechtigungen...</p>
        </div>
      </div>
    );
  }

  // If not logged in, redirect to login
  if (!familyUser) {
    return <Navigate to="/family/login" replace />;
  }

  // If not admin, redirect to dashboard
  if (familyUser.role !== 'admin') {
    return <Navigate to="/family/dashboard" replace />;
  }

  // User is admin, render the protected content
  return children;
}

export default RequireAdmin;
